<a *ngIf="data.link"
	[ngStyle]="{'color': isGGStaticPage ? ggStaticColors.secondary : ''}"
	class="cta"
	[href]="data.link | dcsgSanitizeUrl"
	[attr.data-em]="createTag(data.linkTitle)"
	[attr.target]="targetService(data.link)"
	[attr.aria-label]="title">
	{{data.linkTitle}}
	<i *ngIf="ctaIcon() !== ''" class="cta__icon material-icons">{{ ctaIcon() }}</i>
</a>